import { render, staticRenderFns } from "./AccessRepair.vue?vue&type=template&id=50cbc89c"
import script from "./AccessRepair.vue?vue&type=script&lang=ts"
export * from "./AccessRepair.vue?vue&type=script&lang=ts"
import style0 from "./AccessRepair.vue?vue&type=style&index=0&id=50cbc89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports